import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../util/Rest';
import {ACCOUNTSUMMARY} from '../../constants/MicroServiceConstants';

const initialData = {
  favouriteWindowsData: {},
  favouriteWindowsStatus: null,
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'favouriteWindows',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchFavouriteWindowsData: (state, action) => {
      state.favouriteWindowsData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      // state.successMsg = null;
    },
    resetFavoriteWindow: (state) => {
      state.favouriteWindowsData = {};
    },
    postFavouriteWindowsData: (state, action) => {
      state.favouriteWindowsStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    resetFavouriteWindows: (state) => {
      state.favouriteWindowsStatus = null;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.error ? action.payload.data.error : action.payload;
      state.isLoading = false;
    },
    resetSuccess: (state) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

export const {
  fetchFavouriteWindowsData,
  postFavouriteWindowsData,
  fetchStart,
  resetFavouriteWindows,
  resetSuccess,
  fetchError,
  resetFavoriteWindow,
} = slice.actions;

export const fetchFavouriteWindows = (createdBy) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`${ACCOUNTSUMMARY}/find/window/${createdBy}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchFavouriteWindowsData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const postFavouriteWindows = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${ACCOUNTSUMMARY}/update/windowname`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postFavouriteWindowsData(data));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const SuccessMsg = () => {
  return (dispatch) => {
    dispatch(resetSuccess());
  };
};
export const resetFavouriteWindowsStatus = () => {
  return (dispatch) => {
    dispatch(resetFavouriteWindows());
  };
};
